<section class="flex flex-col w-full eligibility">
  <go-back class="w-full mb-4 flex flex-start sm:hidden"></go-back>
  <div class="text-center pb-8 md:pb-20 header">
    <h1 class="outfit extra-bold pb-6 md:pb-8 heading-large">{{ uniganaEligibility.title | translate }}</h1>
    <p class="paragraph-medium outfit font-normal">{{ uniganaEligibility.description | translate }}</p>
  </div>
  <div class="w-full flex flex-col justify-between items-start md:flex-row gap-8 pb-20 sm:pb-10">
    <div
      class="flex md:flex-[0.6] w-full justify-start lg:self-stretch md:justify-start items-center flex-col gap-8 sm:gap-4"
    >
      <p class="paragraph-medium font-normal text-center md:text-start inline-block outfit">
        {{ uniganaEligibility.automaticallyEligible | translate }}
      </p>
      <div class="w-72 h-auto">
        <img [src]="uniganaEligibility.illustrationMobile" alt="" class="w-full block md:hidden object-cover" />
      </div>
      <p class="paragraph-medium font-normal text-center md:text-start inline-block outfit">
        {{ uniganaEligibility.normallyEligbile | translate }}
      </p>
    </div>
    <div class="w-full md:flex-[0.5] h-full flex justify-center self-stretch items-center">
      <img
        [src]="uniganaEligibility.illustration"
        alt=""
        class="w-full min-h-full shrink-0 hidden md:block object-cover"
      />
    </div>
  </div>
</section>
